import { PowerTransformerPowerState } from './types';

const state = (): PowerTransformerPowerState => {
  return {
    powerTransformerPowers: [],
  };
};

export default state;
